import { render, staticRenderFns } from "./AdvertClicks.vue?vue&type=template&id=2d90d30a&scoped=true"
import script from "./AdvertClicks.vue?vue&type=script&lang=js"
export * from "./AdvertClicks.vue?vue&type=script&lang=js"
import style0 from "./AdvertClicks.vue?vue&type=style&index=0&id=2d90d30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d90d30a",
  null
  
)

export default component.exports